import React from "react";
import TagManager from "react-gtm-module";
import { useLocation } from "react-router-dom";
import useUser from "../hooks/useUser";

const TrackPageView = () => {
  const location = useLocation();
  const { userID } = useUser();

  React.useEffect(() => {
    const tagManagerArgs = {
      dataLayer: {
        user_id: userID,
        event: "pageview",
        page: location.pathname,
        page_title: document.title,
        page_location: window.location.href,
        page_path: location.pathname + location.search,
        referrer: document.referrer,
        timestamp: new Date().toISOString(),
        hostname: window.location.hostname,
        language: navigator.language,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  }, [location, userID]);

  return null;
};

export default TrackPageView;
